import { formatNumber } from './formatNumber'

export const getAmount = (amount: number): string => formatNumber(amount || 0)
